<template>
  <div id="Loading" v-show="isLoading">
    <div class="LoadingImg">
      <img src="./../assets/loading.gif">
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Loading',
    computed: {
      isLoading: function() {
        return this.$store.state.isLoading;
      }
    }
  };
</script>

<style lang="scss" scoped>
  #Loading {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background-color: #fff;
    z-index: 1001;
    font-size: 20px;
  }

  .LoadingImg {
    width: 10em;
    position: absolute;
    left: 50%;
    top: 50%;
    margin: -2.34328em 0 0 -5em;

    img {
      width: 100%;
      display: block;
    }
  }

  /*WAP端*/
  @media screen and (max-width: 750px) {
    #Loading {
      font-size: 15px;
    }
  }
</style>